import { render, staticRenderFns } from "./ShippingRow.vue?vue&type=template&id=599cbf92&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ShippingRow.vue?vue&type=script&lang=ts"
export * from "./ShippingRow.vue?vue&type=script&lang=ts"
import style0 from "./ShippingRow.vue?vue&type=style&index=0&id=599cbf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599cbf92",
  null
  
)

export default component.exports